// extracted by mini-css-extract-plugin
export var archive = "index-module--archive--h-kaV";
export var content = "index-module--content--LvJYS";